import React, { useState } from "react";
import ReactPlayer from "react-player";
import { Container, Row, Col } from "react-bootstrap";
import { FaPlay } from "react-icons/fa";
import { H2, P, Span } from "../../components/Typography/index";
import "./IntroductionVideo.css";

// Import video and thumbnail files
import videoFile from "../../assests/videos/intro-video.mp4";
import thumbnail from "../../assests/videos/intro-video-thumbnail.jpg";

function IntroductionVideo() {
  const [showModal, setShowModal] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const videoUrl = videoFile; // Using local video file
  const thumbnailUrl = thumbnail; // Using imported thumbnail

  return (
    <>
      <section className="introduction-video-section py-100">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="section-title text-center">
                <Span className="sub-title">Our Story</Span>
                <H2>PMSS Documentary - Our Journey of Change</H2>
                <P className="video-subtitle">
                  
                   Explore the inspiring journey of Pragati Manav Sewa Sansthan (PMSS) through our comprehensive documentary. 
                  Discover how we've been working tirelessly since 1999 to transform lives in rural Madhya Pradesh through education, 
                  healthcare, livelihood programs, and skill development. Meet the communities we serve and understand the real impact 
                  of collective action and compassion.
                </P>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={8} className="mx-auto">
              <div className="video-description text-center">
                <P>
                 
                </P>
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={8} className="mx-auto">
              <div className="video-thumbnail-container" onClick={() => setShowModal(true)}>
                <img src={thumbnailUrl} alt="Video Thumbnail" className="video-thumbnail" />
                <div className="play-button-overlay">
                  <div className="play-button">
                    <FaPlay className="play-icon" />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Modal Video Popup */}
      {showModal && (
        <div className="video-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setShowModal(false)}>
              ✕
            </button>
            <div className="modal-video-wrapper">
              <ReactPlayer
                url={videoUrl}
                controls
                width="100%"
                height="100%"
                playing={showModal}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                pip={true}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default IntroductionVideo;
